export const state = {
  current: {},
  comeFrom: null,
  managers: [],
  fieldManagers: [],
  banks: [],
  bgsTypes: []
}

export const mutations = {
  SET_CURRENT_CONTRACT (state, contract) {
    state.current = contract
  },
  SET_COME_FROM (state, comeFrom) {
    state.comeFrom = comeFrom
  },
  SET_MANAGERS (state, managers) {
    state.managers = managers
  },
  SET_FIELD_MANAGERS (state, fieldManagers) {
    state.fieldManagers = fieldManagers
  },
  SET_CONTRACTS_FIELD (state, [field, value]) {
    state[field] = value
  }
}

export default {
  state,
  mutations
}
